import { render, staticRenderFns } from "./OTPModal.vue?vue&type=template&id=214bdc94&scoped=true"
import script from "./OTPModal.vue?vue&type=script&lang=js"
export * from "./OTPModal.vue?vue&type=script&lang=js"
import style0 from "./OTPModal.vue?vue&type=style&index=0&id=214bdc94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "214bdc94",
  null
  
)

export default component.exports